import React from "react";

const About = () => {
  return (
    <div>
      <h1 className="display-4">About Pima COVID-19 Data Panel</h1>
      <p className="lead">
        Simple app to visualize the evolution of COVID-19 Pandemic of Pima
        County
      </p>
      <p className="text-secondary">Version 1.0.0</p>
    </div>
  );
};
export default About;
